import * as React from 'react';

function SvgFolderOpenEmpty(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.99 16.97" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M22.35 5.55h-1.53v-1.9a1.92 1.92 0 00-1.94-1.89h-8.07A1.94 1.94 0 008.88-.01H4.54A1.9 1.9 0 002.6 1.76h-.66A1.92 1.92 0 000 3.65v11.43a1.92 1.92 0 001.94 1.91h17.41a2.48 2.48 0 002.34-1.89L24 7.5a1.57 1.57 0 00-1.65-1.95zm-2.6 8.94v.13a.6.6 0 01-.4.39H2.87L5 7.9v-.13c.06-.14.26-.4.4-.4h16.49z" />
    </svg>
  );
}

const MemoSvgFolderOpenEmpty = React.memo(SvgFolderOpenEmpty);
export default MemoSvgFolderOpenEmpty;
